<template>
  <div class="screen">
    <div class="mb-3 px-3">
      <h1 class="display-2" v-if="viewedPresentation.title">
        {{viewedPresentation.title}}
      </h1>
      <h3 class="subheading" v-if="viewedPresentation.presenter">
        By {{viewedPresentation.presenter.name}}
      </h3>
      <div v-if="viewedPresentationDate">
        {{viewedPresentationDate}}
      </div>
    </div>
    <v-tabs
        centered
        v-model="tab"
        background-color="transparent"
        color="primary"
        grow
        icons-and-text
    >
      <v-tab href="#tab-favs">
        Favorites
        <v-icon>star</v-icon>
      </v-tab>

      <v-tab href="#tab-all">
        All
        <v-icon>view_module</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="grey lighten-5">
      <v-tab-item value="tab-favs">
        <div id="fav-slides" class="slides-list text-center pa-2">
          <div v-if="favSlides && favSlides.length === 0" class="text-uppercase caption ma-3">
            No favorite slides
          </div>
          <v-card v-for="slide in favSlides" :key="slide.image" class="slide ma-3 pa-2">
            <img class="slide" :src="slide.image">
          </v-card>
        </div>
      </v-tab-item>

      <v-tab-item value="tab-all">
        <div id="all-slides" class="slides-list text-center pa-2">
          <v-card v-for="slide in viewedPresentation.slides" :key="slide.image"
                  class="slide ma-3 pa-2">
            <img class="slide" :src="slide.image">
          </v-card>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Presentation',

  data() {
    return {
      tab: null
    };
  },

  created() {
    if (this.userId !== '') {
      this.fetchData();
    }

    if (this.isAnonymous) {
      this.$emit('showLoginModal');
    }
  },

  computed: {
    viewedPresentationDate() {
      return this.viewedPresentation.presentationDate && this.viewedPresentation.presentationDate.toDate ? this.viewedPresentation.presentationDate.toDate().toLocaleDateString() : '';
    },
    ...mapGetters([
      'userId',
      'isAnonymous',
      'viewedPresentation',
      'favSlides'
    ])
  },

  watch: {
    userId() {
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      this.$store.dispatch('viewPresentation', this.$route.params.presentationId);
    }
  }
};
</script>

<style lang="scss" scoped>
  .slides-list {
    .slide {
      font-size: 0;

      img {
        width: 100%;
        min-height: 200px;
        background-color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Presentation.vue